export function PanelToggleButton({
  showSecondPanel,
  onToggle,
  firstName,
  secondName,
}: {
  showSecondPanel: boolean
  onToggle: () => void
  firstName: string
  secondName: string
}) {
  return (
    <button
      onClick={onToggle}
      className="absolute right-4 top-4 z-10 rounded-lg border border-gray-300 bg-gray-100 px-3 py-1.5 text-sm text-gray-700 transition-colors hover:bg-gray-200"
      title={showSecondPanel ? 'Show first panel' : 'Show second panel'}
    >
      <span className="flex items-center gap-1">
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
        {showSecondPanel ? firstName : secondName}
      </span>
    </button>
  )
}

export function FirstCard({
  shouldShowOneCard,
  showSecondPanel,
  onTogglePanel,
  firstContent,
  secondContent,
  firstName,
  secondName,
}: {
  shouldShowOneCard: boolean
  showSecondPanel: boolean
  onTogglePanel: () => void
  firstContent: React.ReactNode
  secondContent: React.ReactNode
  firstName: string
  secondName: string
}) {
  return (
    <div className="font-hanken-grotesk relative mx-auto h-full overflow-hidden rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
      {shouldShowOneCard && (
        <PanelToggleButton
          showSecondPanel={showSecondPanel}
          firstName={firstName}
          secondName={secondName}
          onToggle={onTogglePanel}
        />
      )}
      {shouldShowOneCard && showSecondPanel ? secondContent : firstContent}
    </div>
  )
}

export function ResizableSplitter({
  onMouseDown,
  onDoubleClick,
}: {
  onMouseDown: (e: React.MouseEvent) => void
  onDoubleClick: (e: React.MouseEvent) => void
}) {
  return (
    <div
      className="w-2 cursor-col-resize"
      style={{ background: 'transparent', minHeight: '100%' }}
      onMouseDown={onMouseDown}
      onDoubleClick={onDoubleClick}
      aria-label="Resize panel"
      role="separator"
      tabIndex={0}
    />
  )
}

export function SecondCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="font-hanken-grotesk mx-auto h-full overflow-hidden rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
      {children}
    </div>
  )
}
